import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Policies } from './pages/Policies';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3k92om18wo2mb">
      <Routes data-id="element-1" data-mp="3k7i5d7s1k63r">
        <Route element={<Layout data-id="element-3" data-mp="3farfxtucjy5o" />} data-id="element-2" data-mp="3k78bva7sfgtb">
          <Route path="/" element={<Home data-id="element-5" data-mp="3fb17hlv1iddh" />} data-id="element-4" data-mp="3fa850x346a15" />
          <Route path="/policies" element={<Policies data-id="element-7" data-mp="2rknlabz4z8qt" />} data-id="element-6" data-mp="3f8ex7egrljrk" />
          <Route path="*" element={<Home data-id="element-9" data-mp="2rl6v15emuqtr" />} data-id="element-8" data-mp="2rlyqmg88cok1" />
        </Route>
      </Routes>
    </BrowserRouter>;
}